@if (upgradeNeeded && canModify) {
  <div class="notice-block upgrade-notice">
    <h4>It's time for an upgrade</h4>
    <p>
      We've enhanced {{ uiService.productName }}, but to get the latest functionality for this application, you'll need
      to update your access templates by following the steps below.
    </p>
    @if (detailsLoaded && cachedDetails.length > 0) {
      <div>
        <div class="margin-bottom">Here's what you'll get when you update your templates:</div>
        <div class="upgrade-notice-list-container">
          <ul class="margin-top-none">
            @for (rd of displayedDetails; track rd) {
              <li>{{ rd.description }}</li>
            }
            @if (hasMoreDetails) {
              <a [routerLink]="" (click)="toggleShowAll()" class="underline half-margin-top display-block">
                {{ showAllDetails ? 'See less' : '+' + remainingCount + ' more' }}
              </a>
            }
          </ul>
        </div>
      </div>
    }
  </div>
}
